<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Modifier le sous-traitant</h2>
    <p class="page-subtitle">Mettez à jour les informations du sous-traitant</p>
  </div>
  <a routerLink="/sous-traitants" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="stForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations administratives</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="codeComptable">CODE COMPTABLE</label>
            <input type="text" id="codeComptable" formControlName="codeComptable" class="form-control" placeholder="ex: 401ST001">
          </div>
          <div class="form-group col">
            <label for="siret">SIRET</label>
            <input type="text" id="siret" formControlName="siret" class="form-control" placeholder="14 chiffres">
            @if (stForm.get('siret')?.touched && stForm.get('siret')?.errors?.['siret']) {
              <div class="field-error">Le SIRET doit contenir exactement 14 chiffres.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="denomination">DÉNOMINATION / NOM</label>
            <input type="text" id="denomination" formControlName="denomination" class="form-control" placeholder="Nom du sous-traitant">
          </div>
          <div class="form-group col">
            <label for="qualification">QUALIFICATION</label>
            <input type="text" id="qualification" formControlName="qualification" class="form-control" placeholder="ex: Électricité, Plomberie">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Adresse et Localisation</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="adresse">ADRESSE</label>
            <input type="text" id="adresse" formControlName="adresse" class="form-control">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="ville">VILLE</label>
            <input type="text" id="ville" formControlName="ville" class="form-control">
          </div>
          <div class="form-group col">
            <label for="codePostal">CODE POSTAL</label>
            <input type="text" id="codePostal" formControlName="codePostal" class="form-control">
            @if (stForm.get('codePostal')?.touched && stForm.get('codePostal')?.errors?.['codePostal']) {
              <div class="field-error">Le code postal doit contenir exactement 5 chiffres.</div>
            }
          </div>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }
      <div class="form-actions">
        <div class="form-actions-left">
          @if (!isArchived()) {
            <button type="button" (click)="onDeleteClick()" class="btn btn-danger" [disabled]="isLoading()">
              {{ canDelete() ? 'Supprimer' : 'Archiver' }}
            </button>
          }
        </div>
        <div class="form-actions-right">
          <button type="button" routerLink="/sous-traitants" class="btn btn-outline">Annuler</button>
          <button type="submit" [disabled]="stForm.invalid || isLoading()" class="btn btn-primary">
            {{ isLoading() ? 'Mise à jour en cours...' : 'Mettre à jour' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-confirm-dialog
  *ngIf="showDeleteModal()"
  [title]="canDelete() ? 'Supprimer le sous-traitant' : 'Archiver le sous-traitant'"
  [message]="canDelete()
    ? 'Êtes-vous sûr de vouloir supprimer définitivement le sous-traitant ' + (stForm.value.denomination || '') + ' ?'
    : 'Ce sous-traitant est lié à des projets et ne peut pas être supprimé. Voulez-vous l\'archiver à la place ?'"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>
